import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import DataTable from "../components/DataTable"; // Ajusta la ruta si es necesario

const ListarRegionales = () => {
  const [regionales, setRegionales] = useState([]);
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      const deleteRegional = async (id) => {
        try {
          const result = await Swal.fire({
            icon: "warning",
            title: "¿Estás seguro?",
            text: "Esta acción eliminará la regional. ¿Deseas continuar?",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
          });

          if (result.isConfirmed) {
            const { data } = await axios.delete(`/api/regionales/delete/${id}`);
            Swal.fire("Eliminado", data.message, "success");
            await getData(); // Recargar después de eliminar
          }
        } catch (error) {
          console.error("Error al eliminar:", error.message);
          Swal.fire("Error", "No se pudo eliminar la regional", "error");
        }
      };

      const { data } = await axios.get("/api/regionales/listall/");

      if (data.ok && Array.isArray(data.regionales)) {
        const regionalesOrdenadas = data.regionales
          .sort((a, b) => a.nombreRegional.localeCompare(b.nombreRegional))
          .map((regional) => ({
            ...regional,
            funciones: (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-warning"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => navigate(`/institucional/regional/${regional._id}`)}
                >
                  <i className="fa-solid fa-pen-to-square"></i>
                </button>

                <button
                  className="btn btn-danger"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => deleteRegional(regional._id)}
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            ),
          }));

        setRegionales(regionalesOrdenadas);
      } else {
        console.warn("Respuesta inválida:", data);
        setRegionales([]);
      }
    } catch (error) {
      console.error("Error al obtener regionales:", error.message);
    }
  }, [navigate]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = [
    { Header: "Código", accessor: "codRegional" },
    { Header: "Regional", accessor: "nombreRegional" },
    { Header: "Acciones", accessor: "funciones" },
  ];

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h2 className="mb-4 text-center">Listado de Regionales</h2>

      {regionales.length === 0 ? (
        <p className="text-center">No hay regionales registradas.</p>
      ) : (
        <DataTable columns={columns} data={regionales} />
      )}
    </div>
  );
};

export default ListarRegionales;
